import { createRouter, createWebHistory } from 'vue-router';
import Home from './views/Home';
import Dashboard from './views/Dashboard';
import Login from './views/Login';
import Editor from './views/Editor';
import Preview from './views/Preview';
import Profile from './views/Profile';
import Print from './views/Print';
import Info from './views/Info';
import CreateOrganisation from './views/CreateOrganisation';
import EditOrganisation from './views/EditOrganisation';

const routes = [
  {
    path: '/',
    name: 'home',
    component: Home,
    meta: { transitionName: 'slide-left', noTopbar: true },
  },
  {
    path: '/dashboard',
    name: 'dashboard',
    component: Dashboard,
    meta: {
      middleware: ['auth'],
      transitionName: 'slide-left',
    },
  },
  {
    path: '/profile',
    name: 'profile',
    component: Profile,
    meta: {
      middleware: ['auth'],
      transitionName: 'slide-right',
    },
  },
  {
    path: '/editor/:id',
    name: 'editor',
    component: Editor,
    meta: { transitionName: 'slide-right' },
  },
  {
    path: '/preview/:id',
    name: 'preview',
    component: Preview,
  },
  {
    path: '/resumes/:id/print',
    name: 'print',
    component: Print,
    meta: { noTopbar: true },
  },
  {
    path: '/login',
    name: 'login',
    component: Login,
    meta: { transitionName: 'slide-right', noTopbar: true },
  },
  {
    path: '/register',
    name: 'register',
    component: Login,
    meta: { transitionName: 'slide-right', noTopbar: true },
  },
  {
    path: '/info',
    component: Info,
    meta: { noTopbar: true },
    children: [
      {
        path: 'validateEmail',
        name: 'validateEmail',
      },
      {
        path: 'verifEmail',
        name: 'verifEmail',
      },
      {
        path: 'passwordReset',
        name: 'askResetPassword',
      },
    ],
  },
  {
    path: '/organization/create',
    name: 'createOrganization',
    component: CreateOrganisation,
    meta: {
      middleware: ['auth'],
      transitionName: 'slide-right',
    },
  },
  {
    path: '/organization/edit',
    name: 'editOrganisation',
    component: EditOrganisation,
    meta: {
      middleware: ['auth'],
      transitionName: 'slide-right',
    },
  },
];

const router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),
  routes,
});

export default router;
